var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.is_active)?_c('div',{staticClass:"tag tag--dark tooltip tag--large",attrs:{"data-tooltip":"Inactive"}},[_c('i',{staticClass:"fa fa-wrapper fa-power-off",staticStyle:{"color":"var(--cirrus-white)"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }